// extracted by mini-css-extract-plugin
export var createdDate = "_kk-1";
export var divider = "_kk-2";
export var headerDivider = "_kk-3";
export var messagesCard = "_kk-0";
export var messagesContainer = "_kk-7";
export var messagesContainerWrapper = "_kk-4";
export var pointerCapturingButtonBoxes = "_kk-a";
export var showLeftPanelButton = "_kk-9";
export var showMoreButton = "_kk-c";
export var showMoreButtonContainer = "_kk-b";
export var summaryTitle = "_kk-6";
export var systemMessageCardWrapper = "_kk-d";
export var topButtons = "_kk-8";
export var withPadding = "_kk-5";